import React, { useEffect, useState } from 'react';

import { quotaResetMs, quotaResetText } from '../utils/quotaQueue';

import { overviewTimestamp } from './AiOverviewPanel/overviewDateTime';

import './QuotaQueueNotice.css';

/** Now, refreshed each minute until ``untilMs`` passes (then it stops). */
const useMinuteClock = (untilMs: number): number => {
  const [now, setNow] = useState(Date.now);

  useEffect(() => {
    if (!untilMs || now >= untilMs) return undefined;
    const timer = window.setTimeout(() => setNow(Date.now()), Math.min(60_000, untilMs - now + 500));

    return () => window.clearTimeout(timer);
  }, [now, untilMs]);

  return now;
};

interface QuotaResetLineProps {
  /** When the quota notice was posted (backend timestamps are UTC, often without a zone). */
  postedAt?: string | null;
  /** The notice's gate phase: it names the button that starts the work again. */
  phase: string;
  /** The latest notice: only it still says what to press once the quota has reset. */
  current?: boolean;
}

/** Under a quota notice: how long until the hour's quota resets, ticking each minute, and what to press then. */
export const QuotaResetLine: React.FC<QuotaResetLineProps> = ({ postedAt, phase, current = false }) => {
  const resetMs = quotaResetMs(overviewTimestamp(postedAt));
  const now = useMinuteClock(resetMs);

  if (!resetMs || (now >= resetMs && !current)) return null;

  return <p className="quota-reset-line" role="status">{quotaResetText(resetMs, phase, now)}</p>;
};
